import { PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlightMatch' })
export class HighlightMatchPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(text: string, search: string): SafeHtml | string {
        const pattern = search
            .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

        if(search) {
            const result =
                text.replace(
                    new RegExp(pattern, 'gi'),
                    match => `<span style="font-weight: bold">${match}</span>`);
            return this.sanitizer.bypassSecurityTrustHtml(result);
        }

        return text;
    }
}
